<script>
  import MyPlayer from "./MyPlayer.svelte";
  import Character from "./Character.svelte";
  import ChapterTasks from "./ChapterTasks.svelte";
  import { width, height } from "./stores";
  import { fade } from "svelte/transition";
  import {
    language,
    dialogScreenState,
    dialogChapterTwoScreenState,
    dialogChapterThreeScreenState,
    dialogChapterFourScreenState,
    dialogChapterFiveScreenState,
    dialogChapterSixScreenState,
    chapterOneState,
    chapterTwoState,
    chapterThreeState,
    chapterFourState,
    chapterFiveState,
    chapterSixState,
    mapScreenState,
    sceneChapterOneState,
    playSoundState,
    playerAvatar,
    playerName
  } from "./stores";
  // import TopMenu from "./TopMenu.svelte";
  import howler from "howler";

  let playSoundStateValue;
  playSoundState.subscribe(value => {
    playSoundStateValue = value;
  });

  let clickSound = new Howl({
    src: [
      "public/music/Clicks_01.mp3"
    ],
    preload: true,
    volume: 0.8,
    loop: false
  });

  let dialogSound = new Howl({
    src: [
      "public/music/Clicks_04.mp3"
    ],
    preload: true,
    volume: 0.8,
    loop: false
  });

  function goBackToMap() {
    if (playSoundStateValue && !clickSound.playing()) {
      clickSound.play();
    }
    mapScreenState.set(true);
    if ($chapterOneState) {
      dialogScreenState.set(false);
    }
    if ($chapterTwoState) {
      dialogChapterTwoScreenState.set(false);
    }
    if ($chapterThreeState) {
      dialogChapterThreeScreenState.set(false);
    }
  }

  // let cloudBGScale;
  // let cloudBGTop;
  // width.subscribe(value => {
  //   cloudBGScale = value / 1920;
  // });
  // height.subscribe(value => {
  //   cloudBGTop = value - 319;
  // });
  let dialogWidth;
  let heroWidth;
  let heroHeight;
  let avatarWidth;
  let avatarNameWidth;
  let cloudWidth;
  let cloudHeight;
  let cloudLeft;
  let buttonsWidth;
  let buttonsLeft;
  let nextButtonWidth;
  let nextButtonBottom;
  let skipButtonWidth;
  let previousButtonWidth;
  let textWidth;
  let fontSize;

  let prevButtonColor1 = "#FAF7E4";
  let prevButtonColor2 = "#FAF7E4";

  let widthValue;
  width.subscribe(value => {
    widthValue = value;
    if (widthValue > 1500) {
      widthValue = 1500;
    }
    dialogWidth = widthValue * 0.95;
    heroWidth = widthValue * 0.24;
    avatarWidth = widthValue * 0.24;
    avatarNameWidth = widthValue * 0.17;
    heroHeight = widthValue * 0.29;
    cloudWidth = widthValue * 0.5;
    cloudHeight = widthValue * 0.15;
    cloudLeft = widthValue * 0.25;
    buttonsWidth = widthValue * 0.33;
    buttonsLeft = Math.round(widthValue * 0.175);
    nextButtonWidth = widthValue * 0.075;
    nextButtonBottom = -nextButtonWidth / 2;
    previousButtonWidth = widthValue * 0.075;
    skipButtonWidth = widthValue * 0.09;
    if (skipButtonWidth < 40) {
      skipButtonWidth = 40;
    }
    textWidth = cloudWidth * 0.8;
    fontSize = widthValue * 0.017;
  });

  let text = [
    "Что говоришь? Не расслышал.",
    "Говорю, давай наоборот. Тут распишем права человека, а слева — свободы?",
    "Давай. А дальше тогда картинки с примерами.",
    "Ребят, вы чего тут на полу?",
    "Презентацию делаем к обществознанию.",
    "А почему здесь?",
    "А где нам ещё её делать? Да и мы уже привыкли.",
    "Спина не болит? Неудобно же.",
    "Шея затекает, да. Но ты же знаешь, что все подоконники заняты.",
    "Да, на них хоть поспать можно!",
    "Есть такое, вчера сама видела. Все орут и носятся, как ты вообще там уснул?.",
    "Поверь, после физики, алгебры и двух уроков физ-ры ты бы смогла тоже.",
    "По фактам. Подумаю, как можно сделать коридор удобнее!"
  ];

  let textDe = [
    "Was hast du gesagt? Ich habe dich nicht verstanden.",
    "Ich sagte, machen wir es andersherum. Hier rechts schreiben wir Menschenrechte und links Freiheit, einverstanden?",
    "OK. Und dann kommen Bilder mit Beispielen.",
    "Was macht ihr denn hier auf dem Boden?",
    "Wir arbeiten an einer Präsentation für Sozialkunde.",
    "Und warum macht ihr das hier?",
    "Wo sonst? Hier ist es nicht schlecht. Wir sind daran gewöhnt.",
    "Tut dir nicht dein Rücken weh? Das ist doch unbequem.",
    "Ja, stimmt, mein Hals ist schon ganz steif. Manchmal sitzen wir auf der Fensterbank, dort ist es besser. Aber jetzt sind alle Fensterbänke besetzt.",
    "Ja, genau, da kann man sich gut entspannen!",
    "Ja, das habe ich gestern gesehen. Alle schreien durcheinander, und du schläfst beinahe auf der Fensterbank ein. Also, ich könnte mich da nicht entspannen.",
    "Nach Physik, Algebra und zwei Sportstunden könntest du es, glaub mir. Und außerdem gibt es sowieso keinen anderen Platz.",
    "Hmm. Ich werde darüber nachdenken, wie man den Korridor praktischer und angenehmer gestalten kann!"
  ];

  let currentText = 0;
  let dialogText;
  if ($language == "russian") {
    dialogText = text[currentText];
  } else if ($language == "deutsch") {
    dialogText = textDe[currentText];
  }
  let showTasks = false;
  let textAlign = "left";

  function switchDialogText() {
    if (playSoundStateValue) {
      dialogSound.play();
    }

    currentText++;
    if ($language == "russian") {
      dialogText = text[currentText];
    } else if ($language == "deutsch") {
      dialogText = textDe[currentText];
    }
    switchPersons();
    if (currentText == text.length) {
      skipDialog();
    }

    prevButtonColor1 = "#EC6400";
    prevButtonColor2 = "white";
    // if (currentText > text.length) {
    //   currentText = 0;
    // }
  }

  function switchToPreviousDialogText() {
    if (playSoundStateValue) {
      dialogSound.play();
    }

    currentText--;
    if ($language == "russian") {
      dialogText = text[currentText];
    } else if ($language == "deutsch") {
      dialogText = textDe[currentText];
    }
    switchPersons();
    if (currentText < 0) {
      currentText = 0;
      if ($language == "russian") {
        dialogText = text[currentText];
      } else if ($language == "deutsch") {
        dialogText = textDe[currentText];
      }
    }
    if (currentText == 0) {
      prevButtonColor1 = "#FAF7E4";
      prevButtonColor2 = "#FAF7E4";
    } else {
      prevButtonColor1 = "#EC6400";
      prevButtonColor2 = "white";
    }
  }

  function skipDialog() {
    currentText = 0;
    showTasks = true;

    if ($language == "russian") {
      dialogText = text[currentText];
    } else if ($language == "deutsch") {
      dialogText = textDe[currentText];
    }
    switchPersons();

    if (playSoundStateValue) {
      dialogSound.play();
    }
  }

  let leftPersonColor = "#FEF501";
  let rightPersonColor = "white";

  let DavidIsTalking = true;
  let VaryaIsTalking = false;
  let PlayerIsTalking = true;
  // let LSIsTalking = false;

  function switchPersons() {
    if (
      currentText == 3 ||
      currentText == 5 ||
      currentText == 7 ||
      currentText == 12
    ) {
      leftPersonColor = "white";
      rightPersonColor = "#FEF501";
      // MehdiIsTalking = true;
      textAlign = "right";
    }
    if (
      currentText == 0 ||
      currentText == 2 ||
      currentText == 4 ||
      currentText == 6 ||
      currentText == 9 ||
      currentText == 11
    ) {
      DavidIsTalking = true;
      VaryaIsTalking = false;
      leftPersonColor = "#FEF501";
      rightPersonColor = "white";
      textAlign = "left";
    }
    if (currentText == 1 || currentText == 8 || currentText == 10) {
      VaryaIsTalking = true;
      DavidIsTalking = false;
      leftPersonColor = "#FEF501";
      rightPersonColor = "white";
      textAlign = "left";
    }
    // if (currentText == 2) {
    //   PlayerIsTalking = true;
    //   MehdiIsTalking = false;
    //   // leftPersonColor = "#FEF501";
    //   // rightPersonColor = "white";
    //   // textAlign = "left";
    // }
  }

  // function switchPersonColors() {
  //   if (currentText % 2 != 0) {
  //     leftPersonColor = "#FEF501";
  //     rightPersonColor = "white";
  //     console.log(leftPersonColor, rightPersonColor);
  //   } else {
  //     leftPersonColor = "white";
  //     rightPersonColor = "#FEF501";
  //     console.log(leftPersonColor, rightPersonColor);
  //   }
  // }
  function goToDialogs() {
    if (playSoundStateValue && !clickSound.playing()) {
      clickSound.play();
    }
    // chapterOneState.set(false);
    showTasks = false;
    if ($chapterOneState) {
      dialogScreenState.set(true);
    }
    if ($chapterTwoState) {
      dialogChapterTwoScreenState.set(true);
    }
    if ($chapterThreeState) {
      dialogChapterThreeScreenState.set(true);
    }
  }

  let playerAvatarValue;
  playerAvatar.subscribe(value => {
    playerAvatarValue = value;
  });
</script>



{#if showTasks}
<button id="backButton" on:click={goToDialogs} style="width: 250px;">
<svg style="margin-right: 10px;" width="41" height="13" viewBox="0 0 41 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40.0202 6.32001H1.18018" stroke="black" stroke-width="3" stroke-miterlimit="10"/>
<path d="M7.46019 12.17C7.46019 6.24 0.180176 6.3 0.180176 6.3C0.180176 6.3 7.44019 6.36 7.44019 0.449997" stroke="black" stroke-width="3" stroke-miterlimit="10"/>
</svg>
{#if $language == "russian"}
назад в диалог
{:else if $language == "deutsch"}
zurück zum Dialog
{/if}
</button>

<ChapterTasks />
{:else}

<button id="backButton" on:click={goBackToMap}>
<svg style="margin-right: 10px;" width="41" height="13" viewBox="0 0 41 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40.0202 6.32001H1.18018" stroke="black" stroke-width="3" stroke-miterlimit="10"/>
<path d="M7.46019 12.17C7.46019 6.24 0.180176 6.3 0.180176 6.3C0.180176 6.3 7.44019 6.36 7.44019 0.449997" stroke="black" stroke-width="3" stroke-miterlimit="10"/>
</svg>
{#if $language == "russian"}
назад
{:else if $language == "deutsch"}
zurück
{/if}
</button>

<div id="dialogContainer" style="width: {$width}px; height: {$height}px;" transition:fade>





<div class="dialog" id="dialog" style="width: {dialogWidth}px;">
<div id="character" style="position: absolute; left: 0px; z-index: 2;">
{#if DavidIsTalking}
{#if $language == "russian"}
<Character characterName="Давид" characterColor="{leftPersonColor}" />
{:else if $language == "deutsch"}
<Character characterName="David" characterColor="{leftPersonColor}" />
{/if}
{:else if VaryaIsTalking}
{#if $language == "russian"}
<Character characterName="Варя" characterColor="{leftPersonColor}" />
{:else if $language == "deutsch"}
<Character characterName="Warja" characterColor="{leftPersonColor}" />
{/if}
<!-- {:else}
<Character characterName="Давид" characterColor="{leftPersonColor}" /> -->
{/if}
</div>

<div id="cloud" style="left: {cloudLeft}px; height: {cloudHeight}px;">
<svg width="{cloudWidth}" height="{cloudHeight}" viewBox="0 0 956 292" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M954.8 112.31C954.8 99.3 949.35 87.57 940.63 79.25C949.36 70.93 954.8 59.2 954.8 46.19C954.8 20.96 934.34 0.5 909.11 0.5C896.06 0.5 884.29 5.98001 875.96 14.76C867.63 5.98001 855.87 0.5 842.81 0.5C829.75 0.5 817.99 5.98001 809.66 14.76C801.33 5.98001 789.57 0.5 776.51 0.5C763.45 0.5 751.74 5.96001 743.42 14.7C735.1 5.96001 723.36 0.5 710.33 0.5C697.3 0.5 685.51 5.98001 677.18 14.76C668.85 5.98001 657.09 0.5 644.03 0.5C643.99 0.5 643.95 0.5 643.91 0.5C643.87 0.5 643.83 0.5 643.79 0.5C630.8 0.5 619.08 5.93001 610.76 14.64C602.44 5.93001 590.72 0.5 577.73 0.5C564.74 0.5 552.91 5.98001 544.58 14.76C536.25 5.98001 524.49 0.5 511.43 0.5C498.37 0.5 486.61 5.98001 478.28 14.76C469.95 5.98001 458.19 0.5 445.13 0.5C432.07 0.5 420.31 5.98001 411.98 14.76C403.65 5.98001 391.89 0.5 378.83 0.5C365.77 0.5 354.01 5.98001 345.68 14.76C337.35 5.98001 325.59 0.5 312.53 0.5C299.47 0.5 287.71 5.98001 279.38 14.76C271.05 5.98001 259.29 0.5 246.23 0.5C233.17 0.5 221.41 5.98001 213.08 14.76C204.75 5.98001 192.99 0.5 179.93 0.5C166.87 0.5 155.11 5.98001 146.78 14.76C138.45 5.98001 126.69 0.5 113.63 0.5C100.57 0.5 88.81 5.98001 80.4799 14.76C72.1499 5.98001 60.39 0.5 47.33 0.5C22.1 0.5 1.63998 20.96 1.63998 46.19C1.63998 59.16 7.04998 70.85 15.73 79.17C6.94998 87.5 1.46997 99.26 1.46997 112.31C1.46997 125.36 6.94998 137.13 15.73 145.46C6.94998 153.79 1.46997 165.55 1.46997 178.61C1.46997 191.67 6.74996 202.99 15.24 211.29C8.81996 217.62 4.26998 225.84 2.47998 235.05C1.81998 238.15 1.45996 241.36 1.45996 244.65C1.45996 244.67 1.45996 244.7 1.45996 244.72C1.45996 244.74 1.45996 244.77 1.45996 244.79C1.45996 244.81 1.45996 244.83 1.45996 244.85C1.45996 244.87 1.45996 244.89 1.45996 244.91C1.45996 244.95 1.45996 244.98 1.45996 245.01C1.45996 245.04 1.45996 245.08 1.45996 245.11C1.45996 270.34 21.92 290.8 47.15 290.8C60.57 290.8 72.64 285.01 81 275.79C89.29 284.24 100.84 289.49 113.61 289.49C126.38 289.49 138.43 284.01 146.76 275.23C155.09 284.01 166.85 289.49 179.91 289.49C192.97 289.49 204.73 284.01 213.06 275.23C221.39 284.01 233.15 289.49 246.21 289.49C259.27 289.49 271.03 284.01 279.36 275.23C287.69 284.01 299.45 289.49 312.51 289.49C325.57 289.49 337.33 284.01 345.66 275.23C353.99 284.01 365.75 289.49 378.81 289.49C391.87 289.49 403.63 284.01 411.96 275.23C420.29 284.01 432.05 289.49 445.11 289.49C458.17 289.49 469.93 284.01 478.26 275.23C486.59 284.01 498.35 289.49 511.41 289.49C524.47 289.49 536.23 284.01 544.56 275.23C552.89 284.01 564.65 289.49 577.71 289.49C590.77 289.49 602.11 284.2 610.41 275.7C618.74 284.51 630.52 290.01 643.6 290.01C656.68 290.01 668.84 284.33 677.19 275.28C685.51 284.03 697.26 289.49 710.29 289.49C723.32 289.49 735.06 284.03 743.38 275.29C751.7 284.03 763.44 289.49 776.47 289.49C789.5 289.49 801.29 284.01 809.62 275.23C817.95 284.01 829.71 289.49 842.77 289.49C855.83 289.49 867.15 284.21 875.45 275.72C883.8 284.79 895.76 290.47 909.06 290.47C934.29 290.47 954.75 270.01 954.75 244.78C954.75 244.62 954.74 244.45 954.74 244.29C954.74 244.13 954.75 243.97 954.75 243.8C954.75 231.03 949.51 219.49 941.06 211.2C949.51 202.91 954.75 191.37 954.75 178.6C954.75 165.83 949.27 153.78 940.49 145.45C949.27 137.12 954.75 125.36 954.75 112.3L954.8 112.31Z" fill="white" stroke="black" stroke-miterlimit="10"/>
</svg>
<div class="buttons" style="width:{buttonsWidth}px; margin-left: {buttonsLeft}px; bottom: {nextButtonBottom}px;">
<div id="previousButton" on:click={switchToPreviousDialogText}>
<svg width="{previousButtonWidth}" height="{previousButtonWidth}" viewBox="0 0 144 143" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M75.1603 142.46C112.489 142.46 142.75 112.199 142.75 74.8702C142.75 37.5413 112.489 7.28027 75.1603 7.28027C37.8314 7.28027 7.57031 37.5413 7.57031 74.8702C7.57031 112.199 37.8314 142.46 75.1603 142.46Z" fill="{prevButtonColor1}" stroke="black" stroke-miterlimit="10"/>
<path d="M68.59 135.89C105.919 135.89 136.18 105.629 136.18 68.2999C136.18 30.971 105.919 0.709961 68.59 0.709961C31.261 0.709961 1 30.971 1 68.2999C1 105.629 31.261 135.89 68.59 135.89Z" fill="{prevButtonColor2}" stroke="black" stroke-miterlimit="10"/>
<path d="M109.625 37.2001C106.815 41.5901 104.025 46.0001 101.195 50.3801C98.115 55.1601 95.005 59.9101 91.905 64.6701C90.115 67.4101 90.125 68.8501 91.905 71.6201C97.745 80.6501 103.575 89.6901 109.405 98.7301C109.615 99.0501 109.795 99.3801 109.875 99.9001C107.775 99.0701 76.335 84.9401 62.715 78.7101C62.095 78.4301 61.465 78.1801 60.825 77.9901C60.075 77.7701 59.565 78.1401 59.445 78.9901C59.355 79.6101 59.325 80.2501 59.325 80.8801C59.325 88.5101 59.345 96.1301 59.355 103.76C59.355 104.09 59.355 104.42 59.355 105.16C58.625 104.71 38.265 81.6201 28.615 70.4101C26.855 68.3601 26.845 67.9501 28.595 65.9301C38.205 54.8301 59.285 31.3502 59.365 31.4102C59.365 31.8402 59.365 32.2801 59.365 32.7101C59.365 40.0801 59.365 47.4401 59.365 54.8101C59.365 55.6601 59.415 56.5201 59.505 57.3701C59.595 58.2501 60.085 58.5901 60.865 58.3301C61.445 58.1401 62.015 57.9401 62.575 57.6901C76.895 51.2001 108.775 36.9901 109.535 36.8101L109.645 37.2202L109.625 37.2001Z" fill="{prevButtonColor1}"/>
<path d="M109.625 37.2001C106.815 41.5901 104.025 46.0001 101.195 50.3801C98.115 55.1601 95.005 59.9101 91.905 64.6701C90.115 67.4101 90.125 68.8501 91.905 71.6201C97.745 80.6501 103.575 89.6901 109.405 98.7301C109.615 99.0501 109.795 99.3801 109.875 99.9001C107.775 99.0701 76.335 84.9401 62.715 78.7101C62.095 78.4301 61.465 78.1801 60.825 77.9901C60.075 77.7701 59.565 78.1401 59.445 78.9901C59.355 79.6101 59.325 80.2501 59.325 80.8801C59.325 88.5101 59.345 96.1301 59.355 103.76C59.355 104.09 59.355 104.42 59.355 105.16C58.625 104.71 38.265 81.6201 28.615 70.4101C26.855 68.3601 26.845 67.9501 28.595 65.9301C38.205 54.8301 59.285 31.3502 59.365 31.4102C59.365 31.8402 59.365 32.2801 59.365 32.7101C59.365 40.0801 59.365 47.4401 59.365 54.8101C59.365 55.6601 59.415 56.5201 59.505 57.3701C59.595 58.2501 60.085 58.5901 60.865 58.3301C61.445 58.1401 62.015 57.9401 62.575 57.6901C76.895 51.2001 108.775 36.9901 109.535 36.8101L109.645 37.2202L109.625 37.2001Z" fill="{prevButtonColor1}" stroke="black" stroke-miterlimit="10"/>
</svg>
</div>
<div id="nextButton" on:click="{switchDialogText}">
<svg width="{nextButtonWidth}" height="{nextButtonWidth}" viewBox="0 0 144 143" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M75.4806 142.46C112.81 142.46 143.071 112.199 143.071 74.8702C143.071 37.5413 112.81 7.28027 75.4806 7.28027C38.1517 7.28027 7.89062 37.5413 7.89062 74.8702C7.89062 112.199 38.1517 142.46 75.4806 142.46Z" fill="#EC6400" stroke="black" stroke-miterlimit="10"/>
<path d="M68.9103 135.89C106.239 135.89 136.5 105.629 136.5 68.2999C136.5 30.971 106.239 0.709961 68.9103 0.709961C31.5814 0.709961 1.32031 30.971 1.32031 68.2999C1.32031 105.629 31.5814 135.89 68.9103 135.89Z" fill="#FEF501" stroke="black" stroke-miterlimit="10"/>
<path d="M27.8594 99.3702C30.6694 94.9802 33.4594 90.5702 36.2894 86.1902C39.3694 81.4102 42.4794 76.6602 45.5794 71.9002C47.3694 69.1602 47.3594 67.7202 45.5794 64.9502C39.7394 55.9202 33.9094 46.8802 28.0794 37.8402C27.8694 37.5202 27.6894 37.1902 27.6094 36.6702C29.7094 37.5002 61.1494 51.6302 74.7694 57.8602C75.3894 58.1402 76.0194 58.3902 76.6594 58.5802C77.4094 58.8002 77.9194 58.4302 78.0394 57.5802C78.1294 56.9602 78.1594 56.3202 78.1594 55.6902C78.1594 48.0602 78.1394 40.4402 78.1294 32.8102C78.1294 32.4802 78.1294 32.1502 78.1294 31.4102C78.8594 31.8602 99.2194 54.9502 108.869 66.1602C110.629 68.2102 110.639 68.6202 108.889 70.6402C99.2794 81.7402 78.1994 105.22 78.1194 105.16C78.1194 104.73 78.1194 104.29 78.1194 103.86C78.1194 96.4902 78.1194 89.1302 78.1194 81.7602C78.1194 80.9102 78.0694 80.0502 77.9794 79.2002C77.8894 78.3202 77.3994 77.9802 76.6194 78.2402C76.0394 78.4302 75.4694 78.6302 74.9094 78.8802C60.5894 85.3702 28.7094 99.5802 27.9494 99.7602L27.8394 99.3502L27.8594 99.3702Z" fill="#EC6400"/>
<path d="M27.8594 99.3702C30.6694 94.9802 33.4594 90.5702 36.2894 86.1902C39.3694 81.4102 42.4794 76.6602 45.5794 71.9002C47.3694 69.1602 47.3594 67.7202 45.5794 64.9502C39.7394 55.9202 33.9094 46.8802 28.0794 37.8402C27.8694 37.5202 27.6894 37.1902 27.6094 36.6702C29.7094 37.5002 61.1494 51.6302 74.7694 57.8602C75.3894 58.1402 76.0194 58.3902 76.6594 58.5802C77.4094 58.8002 77.9194 58.4302 78.0394 57.5802C78.1294 56.9602 78.1594 56.3202 78.1594 55.6902C78.1594 48.0602 78.1394 40.4402 78.1294 32.8102C78.1294 32.4802 78.1294 32.1502 78.1294 31.4102C78.8594 31.8602 99.2194 54.9502 108.869 66.1602C110.629 68.2102 110.639 68.6202 108.889 70.6402C99.2794 81.7402 78.1994 105.22 78.1194 105.16C78.1194 104.73 78.1194 104.29 78.1194 103.86C78.1194 96.4902 78.1194 89.1302 78.1194 81.7602C78.1194 80.9102 78.0694 80.0502 77.9794 79.2002C77.8894 78.3202 77.3994 77.9802 76.6194 78.2402C76.0394 78.4302 75.4694 78.6302 74.9094 78.8802C60.5894 85.3702 28.7094 99.5802 27.9494 99.7602L27.8394 99.3502L27.8594 99.3702Z" fill="#EC6400" stroke="black" stroke-miterlimit="10"/>
</svg>
</div>
<div id="skipButton" on:click={skipDialog} style="position: relative; display: flex; align-items: center; margin-bottom: calc(-0.35 * {skipButtonWidth}px); margin-left: calc(0.65 * {skipButtonWidth}px); width: calc(10 * {skipButtonWidth}px); text-align: left;">
{#if $language == "russian"}
<svg width="{skipButtonWidth}" height="24" viewBox="0 0 146 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.62 20V10.38H4.06V20H1.14V7.86H10.52V20H7.62ZM22.5802 13.92C22.5802 16.0667 22.1935 17.6467 21.4202 18.66C20.6468 19.6733 19.6002 20.18 18.2802 20.18C17.8002 20.18 17.3468 20.12 16.9202 20C16.4935 19.8667 16.1068 19.6267 15.7602 19.28L15.7002 19.3L15.7402 20.92V22.98H12.8002V7.94L14.8402 7.8L15.3802 8.82C15.7668 8.46 16.2135 8.18 16.7202 7.98C17.2268 7.76667 17.7735 7.66 18.3602 7.66C19.0402 7.66 19.6402 7.76667 20.1602 7.98C20.6802 8.18 21.1202 8.52667 21.4802 9.02C21.8402 9.5 22.1135 10.14 22.3002 10.94C22.4868 11.74 22.5802 12.7333 22.5802 13.92ZM19.5802 13.84C19.5802 13.12 19.5402 12.5333 19.4602 12.08C19.3802 11.6133 19.2602 11.2533 19.1002 11C18.9402 10.7333 18.7335 10.5533 18.4802 10.46C18.2268 10.3533 17.9268 10.3 17.5802 10.3C17.1802 10.3 16.8202 10.3867 16.5002 10.56C16.1802 10.7333 15.9268 10.9733 15.7402 11.28V16.68C15.9002 16.9733 16.1268 17.22 16.4202 17.42C16.7135 17.6067 17.0802 17.7 17.5202 17.7C17.8268 17.7 18.1068 17.6533 18.3602 17.56C18.6135 17.4533 18.8268 17.26 19.0002 16.98C19.1868 16.7 19.3268 16.3067 19.4202 15.8C19.5268 15.2933 19.5802 14.64 19.5802 13.84ZM34.0427 13.98C34.0427 15.1267 33.9427 16.1 33.7427 16.9C33.5427 17.7 33.236 18.3533 32.8227 18.86C32.4093 19.3533 31.8827 19.7133 31.2427 19.94C30.6027 20.1533 29.8427 20.26 28.9627 20.26C28.0827 20.26 27.3227 20.1533 26.6827 19.94C26.0427 19.7133 25.5093 19.3533 25.0827 18.86C24.6693 18.3533 24.3627 17.7 24.1627 16.9C23.9627 16.1 23.8627 15.1267 23.8627 13.98C23.8627 12.8333 23.9627 11.86 24.1627 11.06C24.376 10.26 24.6893 9.60667 25.1027 9.1C25.5293 8.59333 26.0627 8.22667 26.7027 8C27.3427 7.77333 28.1027 7.66 28.9827 7.66C29.8627 7.66 30.6227 7.77333 31.2627 8C31.9027 8.22667 32.4227 8.59333 32.8227 9.1C33.236 9.60667 33.5427 10.26 33.7427 11.06C33.9427 11.86 34.0427 12.8333 34.0427 13.98ZM26.8827 13.98C26.8827 14.7667 26.916 15.4067 26.9827 15.9C27.0627 16.3933 27.1893 16.7867 27.3627 17.08C27.536 17.3733 27.7493 17.5733 28.0027 17.68C28.2693 17.7867 28.596 17.84 28.9827 17.84C29.356 17.84 29.6693 17.7867 29.9227 17.68C30.1893 17.56 30.4027 17.36 30.5627 17.08C30.7227 16.7867 30.836 16.3933 30.9027 15.9C30.9827 15.3933 31.0227 14.7533 31.0227 13.98C31.0227 13.2067 30.9827 12.5733 30.9027 12.08C30.836 11.5733 30.7227 11.18 30.5627 10.9C30.4027 10.6067 30.1893 10.4067 29.9227 10.3C29.6693 10.18 29.356 10.12 28.9827 10.12C28.596 10.12 28.2693 10.1733 28.0027 10.28C27.736 10.3867 27.516 10.5867 27.3427 10.88C27.1827 11.1733 27.0627 11.5733 26.9827 12.08C26.916 12.5733 26.8827 13.2067 26.8827 13.98ZM42.3075 20V10.38H38.7475V20H35.8275V7.86H45.2075V20H42.3075ZM49.6277 21.04C50.0143 21.04 50.3477 20.96 50.6277 20.8C50.921 20.6533 51.1543 20.3533 51.3277 19.9L51.3877 19.74L46.6477 7.86H49.9677L52.3077 15.26L52.7677 16.8H52.8277L53.1477 15.22L54.9077 7.86H58.0077L54.2477 19.8C54.0477 20.4267 53.8077 20.96 53.5277 21.4C53.261 21.84 52.9543 22.1933 52.6077 22.46C52.2743 22.74 51.901 22.94 51.4877 23.06C51.0743 23.18 50.6277 23.24 50.1477 23.24C49.4277 23.24 48.7877 23.12 48.2277 22.88L48.4677 20.78C48.8543 20.9533 49.241 21.04 49.6277 21.04ZM66.5408 10.72C66.2741 10.6133 65.9741 10.5267 65.6408 10.46C65.3208 10.3933 65.0074 10.36 64.7008 10.36C64.1941 10.36 63.7608 10.4267 63.4008 10.56C63.0541 10.68 62.7741 10.88 62.5608 11.16C62.3474 11.44 62.1941 11.8133 62.1008 12.28C62.0074 12.7333 61.9608 13.2933 61.9608 13.96C61.9608 15.3067 62.1874 16.2667 62.6408 16.84C63.1074 17.4 63.7741 17.68 64.6408 17.68C65.3608 17.68 66.0141 17.5333 66.6008 17.24L66.8008 19.58C66.1341 20.02 65.2074 20.24 64.0208 20.24C62.3541 20.24 61.0874 19.7333 60.2208 18.72C59.3674 17.7067 58.9408 16.12 58.9408 13.96C58.9408 11.9067 59.3474 10.3467 60.1608 9.28C60.9874 8.21333 62.2941 7.68 64.0808 7.68C64.5474 7.68 65.0141 7.72667 65.4808 7.82C65.9608 7.91333 66.3674 8.03333 66.7008 8.18L66.5408 10.72ZM73.3438 10.42V20H70.4238V10.42H67.4038L67.4638 7.86H76.3038L76.3638 10.42H73.3438ZM77.5658 20V7.86H80.3858V14.04L80.3658 15.34L80.3858 15.36L84.4258 7.86H87.2058V20H84.3658V13.78L84.3858 12.46L84.3458 12.44L83.6658 13.76L80.3458 20H77.5658ZM94.3398 10.42V20H91.4198V10.42H88.3998L88.4598 7.86H97.2998L97.3598 10.42H94.3398ZM107.482 16.04C107.482 17.3333 107.089 18.32 106.302 19C105.515 19.6667 104.249 20 102.502 20H98.5619V7.86H101.482V11.94H102.502C104.235 11.94 105.495 12.2667 106.282 12.92C107.082 13.56 107.482 14.6 107.482 16.04ZM104.482 16C104.482 15.32 104.315 14.86 103.982 14.62C103.662 14.3667 103.162 14.24 102.482 14.24H101.482V17.74H102.502C102.822 17.74 103.102 17.72 103.342 17.68C103.582 17.6267 103.789 17.5333 103.962 17.4C104.135 17.2667 104.262 17.0867 104.342 16.86C104.435 16.6333 104.482 16.3467 104.482 16Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M145.994 14.1347C146.001 13.1831 146 13.1831 146 13.1831L145.999 13.1831L145.996 13.1831L145.989 13.1831L145.981 13.1831L145.977 13.1831C145.967 13.183 145.95 13.1829 145.927 13.1824C145.88 13.1815 145.808 13.1794 145.715 13.1747C145.528 13.1652 145.255 13.1451 144.926 13.103C144.263 13.018 143.396 12.8464 142.543 12.5056C141.689 12.1641 140.891 11.6703 140.31 10.9655C139.743 10.277 139.339 9.33561 139.339 8H137.435C137.435 9.76029 137.982 11.1337 138.841 12.1759C139.155 12.5564 139.504 12.8856 139.872 13.1705L117 13.1705V15.0737L139.907 15.0737C139.53 15.3622 139.173 15.6968 138.852 16.085C137.994 17.1245 137.448 18.4945 137.448 20.2504H139.351C139.351 18.9199 139.754 17.9822 140.32 17.2963C140.9 16.5942 141.696 16.102 142.549 15.7616C143.401 15.4219 144.266 15.2508 144.928 15.1661C145.256 15.1241 145.528 15.1041 145.715 15.0947C145.809 15.09 145.88 15.0879 145.927 15.087C145.95 15.0865 145.967 15.0864 145.977 15.0863L145.981 15.0863L145.989 15.0863L145.996 15.0863L146 15.0863C146 15.0863 146.001 15.0863 145.994 14.1347ZM145.994 14.1347L146.001 13.1831L146.001 15.0863L145.994 14.1347Z" fill="black"/>
</svg>

{:else if $language == "deutsch"}
<svg width="{skipButtonWidth}" height="24" viewBox="0 0 160 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.42 15.86C10.42 17.3133 10.0333 18.4 9.26 19.12C8.5 19.84 7.32667 20.2 5.74 20.2C4.15333 20.2 2.97333 19.8333 2.2 19.1C1.42667 18.3533 1.04 17.2733 1.04 15.86V7.86H3.96V15.84C3.96 16.9867 4.55333 17.56 5.74 17.56C6.34 17.56 6.78667 17.4267 7.08 17.16C7.37333 16.88 7.52 16.44 7.52 15.84V7.86H10.42V15.86ZM5.26 5.26C5.26 6.1 4.84 6.52 4 6.52C3.57333 6.52 3.26 6.42667 3.06 6.24C2.86 6.04 2.76 5.71333 2.76 5.26C2.76 4.39333 3.17333 3.96 4 3.96C4.84 3.96 5.26 4.39333 5.26 5.26ZM8.7 5.26C8.7 6.1 8.28667 6.52 7.46 6.52C7.03333 6.52 6.71333 6.42667 6.5 6.24C6.3 6.04 6.2 5.71333 6.2 5.26C6.2 4.39333 6.62 3.96 7.46 3.96C8.28667 3.96 8.7 4.39333 8.7 5.26ZM22.4453 13.88C22.4453 15.0267 22.3386 16 22.1253 16.8C21.9253 17.6 21.6253 18.26 21.2253 18.78C20.8386 19.2867 20.3653 19.66 19.8053 19.9C19.2453 20.1267 18.6186 20.24 17.9253 20.24C17.2853 20.24 16.7186 20.1267 16.2253 19.9C15.7453 19.6733 15.332 19.38 14.9853 19.02L14.6053 20H12.6653V4.36L15.5853 4.22V7.02L15.5453 8.62L15.6053 8.66C15.9786 8.31333 16.392 8.06 16.8453 7.9C17.2986 7.74 17.772 7.66 18.2653 7.66C18.9053 7.66 19.4853 7.77333 20.0053 8C20.5253 8.22667 20.9653 8.58667 21.3253 9.08C21.6853 9.57333 21.9586 10.2133 22.1453 11C22.3453 11.7867 22.4453 12.7467 22.4453 13.88ZM19.4453 13.94C19.4453 13.1533 19.3986 12.52 19.3053 12.04C19.2253 11.5467 19.0986 11.1733 18.9253 10.92C18.7653 10.6533 18.5586 10.48 18.3053 10.4C18.052 10.3067 17.7653 10.26 17.4453 10.26C17.032 10.26 16.6653 10.3533 16.3453 10.54C16.0253 10.7133 15.772 10.9533 15.5853 11.26V16.78C15.7453 17.06 15.9786 17.3 16.2853 17.5C16.592 17.7 16.9786 17.8 17.4453 17.8C17.7653 17.8 18.0453 17.7533 18.2853 17.66C18.5386 17.5533 18.7453 17.36 18.9053 17.08C19.0786 16.8 19.212 16.4133 19.3053 15.92C19.3986 15.4133 19.4453 14.7533 19.4453 13.94ZM29.3259 20.22C27.3659 20.22 25.9393 19.6933 25.0459 18.64C24.1659 17.5733 23.7259 15.9467 23.7259 13.76C23.7259 11.7733 24.1193 10.26 24.9059 9.22C25.7059 8.18 26.9526 7.66 28.6459 7.66C30.0993 7.66 31.2326 8.10667 32.0459 9C32.8593 9.89333 33.2659 11.3133 33.2659 13.26C33.2659 13.5 33.2593 13.7467 33.2459 14C33.2326 14.2533 33.2126 14.4933 33.1859 14.72H26.7459C26.7993 15.8133 27.0593 16.5733 27.5259 17C27.9926 17.4133 28.7126 17.62 29.6859 17.62C30.2193 17.62 30.7259 17.5733 31.2059 17.48C31.6859 17.3867 32.1593 17.2467 32.6259 17.06L32.9459 19.48C32.4793 19.7067 31.9393 19.8867 31.3259 20.02C30.7126 20.1533 30.0459 20.22 29.3259 20.22ZM30.5859 12.7C30.5593 11.7533 30.3793 11.0933 30.0459 10.72C29.7126 10.3467 29.2526 10.16 28.6659 10.16C27.9993 10.16 27.5126 10.3533 27.2059 10.74C26.9126 11.1133 26.7393 11.7667 26.6859 12.7H30.5859ZM35.0267 20V7.94L37.3667 7.82L37.6067 9.76H37.6667C38.0134 9.05333 38.4467 8.53333 38.9667 8.2C39.4867 7.85333 40.0667 7.68 40.7067 7.68C41.1867 7.68 41.5867 7.73333 41.9067 7.84L41.7267 10.82C41.3801 10.7 40.9801 10.64 40.5267 10.64C39.7801 10.64 39.1601 10.9133 38.6667 11.46C38.1867 11.9933 37.9467 12.76 37.9467 13.76V20H35.0267ZM50.8642 16.24C50.8642 17.4667 50.5242 18.44 49.8442 19.16C49.1642 19.88 48.0709 20.24 46.5642 20.24C45.8976 20.24 45.2709 20.1733 44.6842 20.04C44.1109 19.9067 43.5909 19.7067 43.1242 19.44L43.4242 16.96C43.8642 17.2267 44.3709 17.4267 44.9442 17.56C45.5176 17.6933 46.0376 17.76 46.5042 17.76C47.0909 17.76 47.5109 17.6467 47.7642 17.42C48.0309 17.1933 48.1642 16.8867 48.1642 16.5C48.1642 16.1667 48.0376 15.9067 47.7842 15.72C47.5309 15.52 47.2109 15.3467 46.8242 15.2C46.4509 15.0533 46.0442 14.9 45.6042 14.74C45.1642 14.58 44.7509 14.3667 44.3642 14.1C43.9909 13.8333 43.6776 13.4867 43.4242 13.06C43.1709 12.62 43.0442 12.0533 43.0442 11.36C43.0442 10.8267 43.1309 10.34 43.3042 9.9C43.4776 9.44667 43.7376 9.06 44.0842 8.74C44.4442 8.40667 44.8909 8.14667 45.4242 7.96C45.9576 7.77333 46.5842 7.68 47.3042 7.68C47.8642 7.68 48.4042 7.74 48.9242 7.86C49.4576 7.96667 49.9509 8.11333 50.4042 8.3L50.1842 10.76C49.7309 10.5733 49.2376 10.4333 48.7042 10.34C48.1709 10.2467 47.7042 10.2 47.3042 10.2C46.3176 10.2 45.8242 10.5467 45.8242 11.24C45.8242 11.5467 45.9442 11.7933 46.1842 11.98C46.4376 12.1533 46.7509 12.3133 47.1242 12.46C47.4976 12.5933 47.9042 12.74 48.3442 12.9C48.7842 13.06 49.1909 13.2733 49.5642 13.54C49.9376 13.7933 50.2442 14.14 50.4842 14.58C50.7376 15.0067 50.8642 15.56 50.8642 16.24ZM62.3653 13.92C62.3653 16.0667 61.9786 17.6467 61.2053 18.66C60.432 19.6733 59.3853 20.18 58.0653 20.18C57.5853 20.18 57.132 20.12 56.7053 20C56.2786 19.8667 55.892 19.6267 55.5453 19.28L55.4853 19.3L55.5253 20.92V22.98H52.5853V7.94L54.6253 7.8L55.1653 8.82C55.552 8.46 55.9986 8.18 56.5053 7.98C57.012 7.76667 57.5586 7.66 58.1453 7.66C58.8253 7.66 59.4253 7.76667 59.9453 7.98C60.4653 8.18 60.9053 8.52667 61.2653 9.02C61.6253 9.5 61.8986 10.14 62.0853 10.94C62.272 11.74 62.3653 12.7333 62.3653 13.92ZM59.3653 13.84C59.3653 13.12 59.3253 12.5333 59.2453 12.08C59.1653 11.6133 59.0453 11.2533 58.8853 11C58.7253 10.7333 58.5186 10.5533 58.2653 10.46C58.012 10.3533 57.712 10.3 57.3653 10.3C56.9653 10.3 56.6053 10.3867 56.2853 10.56C55.9653 10.7333 55.712 10.9733 55.5253 11.28V16.68C55.6853 16.9733 55.912 17.22 56.2053 17.42C56.4986 17.6067 56.8653 17.7 57.3053 17.7C57.612 17.7 57.892 17.6533 58.1453 17.56C58.3986 17.4533 58.612 17.26 58.7853 16.98C58.972 16.7 59.112 16.3067 59.2053 15.8C59.312 15.2933 59.3653 14.64 59.3653 13.84ZM64.1478 20V7.94L66.4878 7.82L66.7278 9.76H66.7878C67.1345 9.05333 67.5678 8.53333 68.0878 8.2C68.6078 7.85333 69.1878 7.68 69.8278 7.68C70.3078 7.68 70.7078 7.73333 71.0278 7.84L70.8478 10.82C70.5011 10.7 70.1011 10.64 69.6478 10.64C68.9011 10.64 68.2811 10.9133 67.7878 11.46C67.3078 11.9933 67.0678 12.76 67.0678 13.76V20H64.1478ZM72.9053 20V7.94L75.8853 7.8V20H72.9053ZM76.0453 5.28C76.0453 6.14667 75.4986 6.58 74.4053 6.58C73.8453 6.58 73.4253 6.48 73.1453 6.28C72.8786 6.08 72.7453 5.74667 72.7453 5.28C72.7453 4.4 73.2986 3.96 74.4053 3.96C75.4986 3.96 76.0453 4.4 76.0453 5.28ZM84.9638 20V12.04C84.9638 11.4 84.8104 10.9467 84.5038 10.68C84.2104 10.4133 83.7838 10.28 83.2237 10.28C82.8638 10.28 82.5171 10.36 82.1838 10.52C81.8504 10.68 81.5904 10.8933 81.4038 11.16V20H78.4838V7.92L80.5838 7.78L81.0038 8.8C81.4171 8.42667 81.8838 8.14 82.4038 7.94C82.9238 7.74 83.4771 7.64 84.0638 7.64C85.2371 7.64 86.1638 8.01333 86.8438 8.76C87.5238 9.49333 87.8638 10.5867 87.8638 12.04V20H84.9638ZM94.1862 15.06C93.7196 15.06 93.2663 15.02 92.8263 14.94C92.5729 15.0867 92.4463 15.28 92.4463 15.52C92.4463 15.8533 92.7063 16.04 93.2263 16.08L95.7863 16.28C97.0929 16.3867 98.0263 16.6867 98.5863 17.18C99.1463 17.6733 99.4263 18.3933 99.4263 19.34C99.4263 20.5267 99.0196 21.46 98.2063 22.14C97.4063 22.8333 96.1063 23.18 94.3063 23.18C93.5063 23.18 92.8129 23.1 92.2263 22.94C91.6529 22.7933 91.1796 22.58 90.8063 22.3C90.4329 22.02 90.1529 21.6867 89.9663 21.3C89.7929 20.9267 89.7063 20.5133 89.7063 20.06C89.7063 19.7 89.7796 19.3467 89.9263 19C90.0863 18.6533 90.3196 18.34 90.6263 18.06C90.3596 17.8733 90.1396 17.64 89.9663 17.36C89.8063 17.08 89.7263 16.7333 89.7263 16.32C89.7263 15.92 89.8396 15.54 90.0663 15.18C90.2929 14.8067 90.6463 14.4933 91.1263 14.24C90.7396 13.96 90.4329 13.5933 90.2063 13.14C89.9796 12.6733 89.8663 12.0933 89.8663 11.4C89.8663 10.84 89.9463 10.3333 90.1063 9.88C90.2663 9.42667 90.5129 9.03333 90.8463 8.7C91.1929 8.36667 91.6396 8.11333 92.1863 7.94C92.7329 7.75333 93.3929 7.66 94.1663 7.66C94.6596 7.66 95.1463 7.70667 95.6263 7.8C96.1063 7.89333 96.5463 8.06 96.9463 8.3L98.8863 7.64L99.5063 9.06L98.2863 10.06C98.4063 10.4467 98.4663 10.8933 98.4663 11.4C98.4663 12.5867 98.1263 13.4933 97.4463 14.12C96.7796 14.7467 95.6929 15.06 94.1862 15.06ZM92.7463 18.6C92.5596 18.7467 92.4196 18.9133 92.3263 19.1C92.2463 19.2867 92.2063 19.4667 92.2063 19.64C92.2063 20.0667 92.3596 20.3867 92.6663 20.6C92.9863 20.8133 93.5063 20.92 94.2263 20.92C94.7329 20.92 95.1529 20.8933 95.4863 20.84C95.8196 20.7867 96.0796 20.7067 96.2663 20.6C96.4663 20.5067 96.5996 20.3867 96.6663 20.24C96.7463 20.1067 96.7863 19.9467 96.7863 19.76C96.7863 19.4667 96.6796 19.2533 96.4663 19.12C96.2663 18.9733 95.8663 18.8667 95.2663 18.8L92.7463 18.6ZM94.1862 9.9C93.6529 9.9 93.2796 10.02 93.0663 10.26C92.8529 10.5 92.7463 10.8933 92.7463 11.44C92.7463 11.7467 92.7796 12 92.8463 12.2C92.9129 12.4 93.0063 12.56 93.1263 12.68C93.2463 12.7867 93.3929 12.8667 93.5663 12.92C93.7396 12.96 93.9329 12.98 94.1463 12.98C94.7329 12.98 95.1263 12.8667 95.3263 12.64C95.5396 12.4133 95.6463 12.0133 95.6463 11.44C95.6463 10.8667 95.5329 10.4667 95.3063 10.24C95.0929 10.0133 94.7196 9.9 94.1862 9.9ZM105.986 20.22C104.026 20.22 102.599 19.6933 101.706 18.64C100.826 17.5733 100.386 15.9467 100.386 13.76C100.386 11.7733 100.779 10.26 101.566 9.22C102.366 8.18 103.613 7.66 105.306 7.66C106.759 7.66 107.893 8.10667 108.706 9C109.519 9.89333 109.926 11.3133 109.926 13.26C109.926 13.5 109.919 13.7467 109.906 14C109.893 14.2533 109.873 14.4933 109.846 14.72H103.406C103.459 15.8133 103.719 16.5733 104.186 17C104.653 17.4133 105.373 17.62 106.346 17.62C106.879 17.62 107.386 17.5733 107.866 17.48C108.346 17.3867 108.819 17.2467 109.286 17.06L109.606 19.48C109.139 19.7067 108.599 19.8867 107.986 20.02C107.373 20.1533 106.706 20.22 105.986 20.22ZM107.246 12.7C107.219 11.7533 107.039 11.0933 106.706 10.72C106.373 10.3467 105.913 10.16 105.326 10.16C104.659 10.16 104.173 10.3533 103.866 10.74C103.573 11.1133 103.399 11.7667 103.346 12.7H107.246ZM118.167 20V12.04C118.167 11.4 118.014 10.9467 117.707 10.68C117.414 10.4133 116.987 10.28 116.427 10.28C116.067 10.28 115.72 10.36 115.387 10.52C115.054 10.68 114.794 10.8933 114.607 11.16V20H111.687V7.92L113.787 7.78L114.207 8.8C114.62 8.42667 115.087 8.14 115.607 7.94C116.127 7.74 116.68 7.64 117.267 7.64C118.44 7.64 119.367 8.01333 120.047 8.76C120.727 9.49333 121.067 10.5867 121.067 12.04V20H118.167Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M159.994 14.1347C160.001 13.1831 160 13.1831 160 13.1831L159.999 13.1831L159.996 13.1831L159.989 13.1831L159.981 13.1831L159.977 13.1831C159.967 13.183 159.95 13.1829 159.927 13.1824C159.88 13.1815 159.808 13.1794 159.715 13.1747C159.528 13.1652 159.255 13.1451 158.926 13.103C158.263 13.018 157.396 12.8464 156.543 12.5056C155.689 12.1641 154.891 11.6703 154.31 10.9655C153.743 10.277 153.339 9.33561 153.339 8H151.435C151.435 9.76029 151.982 11.1337 152.841 12.1759C153.155 12.5564 153.504 12.8856 153.872 13.1705L131 13.1705V15.0737L153.907 15.0737C153.53 15.3622 153.173 15.6968 152.852 16.085C151.994 17.1245 151.448 18.4945 151.448 20.2504H153.351C153.351 18.9199 153.754 17.9822 154.32 17.2963C154.9 16.5942 155.696 16.102 156.549 15.7616C157.401 15.4219 158.266 15.2508 158.928 15.1661C159.256 15.1241 159.528 15.1041 159.715 15.0947C159.809 15.09 159.88 15.0879 159.927 15.087C159.95 15.0865 159.967 15.0864 159.977 15.0863L159.981 15.0863L159.989 15.0863L159.996 15.0863L160 15.0863C160 15.0863 160.001 15.0863 159.994 14.1347ZM159.994 14.1347L160.001 13.1831L160.001 15.0863L159.994 14.1347Z" fill="black"/>
</svg>
{/if}
</div>

</div>
</div>

{#if $language == "russian"}
<p style="width:{textWidth}px; text-align: {textAlign}; font-size: calc(0.8 * {fontSize}px); margin-top: 0; padding-top: 0;">
{dialogText}
</p>
{:else if $language == "deutsch"}
<p style="width:{textWidth}px; text-align: {textAlign}; font-size: calc(0.8 * {fontSize}px); margin-top: 0; padding-top: 0;">
{dialogText}
</p>
{/if}

<!-- <button style="background: red; color: white; width: 100px; height: 50px;" on:click={goToSceneChapterOne}>К РЕДАКТОРУ</button> -->

<div id="player" style="position: absolute; right: 0px; z-index: 2;">
<MyPlayer playerColor="{rightPersonColor}" />
</div>

</div>


</div>
{/if}

<style>
  #backButton {
    position: absolute;
    top: 0;
    left: 0px;
    margin: 48px 0 0 70px;
    width: 125px;
    height: 30px;
    background: none;
    border: none;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    font-family: Goethe, sans-serif;
    font-weight: bold;
    font-style: normal;
    font-size: 20px;
    letter-spacing: 0.01em;
    text-decoration: none;
    color: black;
    cursor: pointer;
    z-index: 1;
  }
  #backButton:hover {
    border: 1px solid black;
    border-radius: 25px;
  }

  #dialogContainer {
    background-image: url("images/coridor_bg.jpg");
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
  }

  .dialog {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    margin: auto 50px 180px 50px;
    font-family: Goethe, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 20px;
    line-height: 25px;
    text-decoration: none;
    color: black;
  }

  #dialog p {
    position: absolute;
    width: 100%;
    height: 100px;
    padding: 20px;
  }

  .buttons {
    position: absolute;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    z-index: 5;
  }
  #nextButton,
  #skipButton,
  #previousButton {
    cursor: pointer;
  }
  #nextButton:hover,
  #previousButton:hover {
    transform: scale(1.05);
  }
</style>
